module.exports = __webpack_public_path__ + "media/images/event/btn-aadb3dcbb0ddbe887e0a7b47806523ec.png";